import React from 'react';
import { Fade } from 'react-reveal';
import { useParams } from 'react-router-dom';

import styles from './Dday.module.css';

const Dday = ({ dbData, backgroundPosition, backgroundSize, customClass, textColor }) => {
  const alias = useParams().id;

  const { day, month, time, year } = dbData.weddingDate;
  const date = new Date(`${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${time}`);
  const ddayCount = Math.ceil((date.getTime() - new Date().getTime()) / (60 * 60 * 1000 * 24));

  return (
    <Fade bottom duration={2000}>
      <div className={`${styles.Dday} ${customClass ? styles[customClass] : ''}`}>
        <div
          className={styles.background}
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/gallery/${dbData.galleryAlias || alias}/${dbData.backgrounds.dday})`,
            backgroundPosition: `${backgroundPosition ? backgroundPosition[0] : 50}% ${backgroundPosition ? backgroundPosition[1] : 0}%`,
            backgroundSize: backgroundSize || '150%',
          }}
        />
        <div className={styles.contents}>
          <div style={{ color: textColor || 'black' }}>
            <span>D</span>
            <span>{ddayCount < 0 ? '+' : ''}</span>
            <span>{ddayCount * -1}</span>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Dday;
